import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { ErrorPolicyService } from '@mri-platform/angular-error-handling';
import { routeResolveEntities, RoutingEventsService } from '@mri-platform/shared/core';
import { Observable } from 'rxjs';
import { OrganisationPrincipal } from '../models';
import { OrganisationRepositoryService } from './organisation-repository.service';

@Injectable({ providedIn: 'root' })
export class OrganisationDtoResolver implements Resolve<OrganisationPrincipal[]> {
  constructor(
    private readonly repo: OrganisationRepositoryService,
    private readonly router: Router,
    private readonly routingEvents: RoutingEventsService,
    private readonly errorPolicyService: ErrorPolicyService
  ) {}

  resolve(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<OrganisationPrincipal[]> {
    return this.routingEvents.isInitialNavigation$.pipe(
      routeResolveEntities(
        () => this.repo.executeQuery(this.repo.baseQuery.noTracking().withParameters({ includeDeleted: true })),
        this.router,
        this.errorPolicyService
      )
    );
  }
}
